export { default as AppMain } from './AppMain';
export { default as Navbar } from './Navbar';
export { default as Settings } from './Settings';
export { default as Sidebar } from './Sidebar/index.vue';
export { default as TagsView } from './TagsView/index.vue';
export { default as Contact } from './Contact/index.vue';
export { default as WelcomeDialog } from './WelcomeDialog';
